<template>
  <div id="checkout-layout">
    <base-button class="discount-alert" @click="handleAlertClick">
      <div>
        <span
          >Now Available: <strong>Professional Design Services</strong></span
        >
        <i class="fas fa-external-link-alt"></i>
      </div>
    </base-button>
    <!-- HEADER -->
    <!-- <div class="header bg-primary py-4">
      <div :class="containerClasses">
        <div class="header-body text-center mb-5">
          <div class="row justify-content-center"></div>
        </div>
      </div>
    </div> -->
    <fade-transition
      :duration="pageTransitionDuration"
      mode="out-in"
      @after-leave="$root.$emit('triggerScroll')"
    >
      <router-view></router-view>
    </fade-transition>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition,
  },
  // metaInfo() {
  //   return {
  //     title: "Art Grab : Exclusive cover art and image licensing",
  //     meta: [
  //       {
  //         vmid: "twitter:card",
  //         name: "twitter:card",
  //         content: `summary_large_image`,
  //       },
  //       { vmid: "twitter:title", name: "twitter:title", content: `Art Grab` },
  //       {
  //         vmid: "twitter:description",
  //         name: "twitter:description",
  //         content: `Exclusively license images created by world-renowned artists. Use them for album covers, posters, merchandise, and more.`,
  //       },
  //       {
  //         vmid: "twitter:image",
  //         name: "twitter:image",
  //         content: "https://i.imgur.com/gp9AfzO.jpeg",
  //       },
  //       { vmid: "og:url", property: "og:url", content: `https://artgrab.co` },
  //       { vmid: "og:title", property: "og:title", content: `Art Grab` },
  //       {
  //         vmid: "og:description",
  //         property: "og:description",
  //         content: `Exclusively license images created by world-renowned artists. Use them for album covers, posters, merchandise, and more.`,
  //       },
  //       {
  //         vmid: "og:image",
  //         property: "og:image",
  //         content: "https://i.imgur.com/gp9AfzO.jpeg",
  //       },
  //       {
  //         vmid: "description",
  //         name: "description",
  //         content:
  //           "Your source for exclusive art. Exclusively license and download images created by world-renowned artists. Use them for album covers, posters, merchandise, and more.",
  //       },
  //     ],
  //   };
  // },
  data() {
    return {
      menuTransitionDuration: 250,
      pageTransitionDuration: 100,
      isInstagram: false,
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
    containerClasses() {
      let classes = "container";

      // if (this.isInstagram) {
      //   classes += " simple-instagram-nav";
      // }

      return classes;
    },
  },
  methods: {
    handleAlertClick() {
      this.$router.push({ path: "/professional-design-services" });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
  },
  mounted() {
    if (this.$route.query.referral) {
      this.$store.commit("setReferral", this.$route.query.referral);
    }
    this.isInstagram = navigator.userAgent.match(/instagram/i);
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  watch: {
    $route(to, from) {
      const pageName = to.name.toUpperCase().replace(/\s+/g, "");

      if (this.$route.query.referral) {
        this.$store.commit("setReferral", this.$route.query.referral);
      }

      this.updateBackground();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.simple-instagram-nav {
  margin-top: 60px;
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

#checkout-layout {
  height: calc(100vh);
  width: 100%;
  overflow-y: auto;
  display: flex;

  .header-body {
    .logo {
      width: 240px;
    }
  }
}

@media (max-width: 575.98px) {
  #checkout-layout {
    .header-body {
      .logo {
        width: 180px;
      }
    }
  }
}
</style>
